import { light } from './light';
import { dark } from './dark';
import { pink } from './pink';
import { yellow } from './yellow';

export const themes = {
  light,
  dark,
  pink,
  yellow,
};
